import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    field: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      gap: theme.spacing(1),
      padding: theme.spacing(2),
      backgroundColor: COLORS.gray.white,
      border: theme.shape.borderGray70,
      borderRadius: theme.shape.borderRadius,
      '&$disabled': {
        backgroundColor: COLORS.gray.gray90,
      },
    },
    disabled: {},
    title: {
      flex: 1,
      color: COLORS.gray.black,
    },
    icon: {
      marginLeft: theme.spacing(0.5),
      fontSize: theme.typography.pxToRem(16),
      color: COLORS.gray.gray40,
    },
    switch: {},
  }),
  { name: 'BlockBrandVocabulary' }
);
